import React from "react";
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";

export const AlertSkeleton = () => (
    <React.Fragment>
        <Skeleton  variant="rect" height={90} style={{margin:'10px 0',borderRadius:4}}/>
    </React.Fragment>
)